import { SearchFilters, SearchTypes } from "@/constants/filters";

// Room-level search filters (those that can differ between rooms of the same
// house) forwarded to the detail endpoint so it can flag non-matching siblings.
const ROOM_FILTER_KEYS: SearchFilters[] = [
  SearchFilters.MIN_RENT_PRICE,
  SearchFilters.MAX_RENT_PRICE,
  SearchFilters.AVAILABLE_FROM,
  SearchFilters.AVAILABLE_TO,
  SearchFilters.GENDER,
  SearchFilters.PET_FRIENDLY,
  SearchFilters.CONTRACT,
  SearchFilters.SMOKING_ALLOWED,
  SearchFilters.ROOM_FEATURES,
  SearchFilters.HOUSE_FEATURES,
];

export function buildRoomFilterParams(
  params: Record<string, string | null | undefined>,
): Record<string, string> | undefined {
  const out: Record<string, string> = {};
  for (const key of ROOM_FILTER_KEYS) {
    const value = params[key];
    if (value) out[key] = value;
  }
  return Object.keys(out).length > 0 ? out : undefined;
}

// Query string (room filters + businessType) to carry the active search onto a
// shared/expanded room link, or undefined when no room filter is active.
export function buildRoomFilterQuery(
  params: Record<string, string | null | undefined>,
): string | undefined {
  const filters = buildRoomFilterParams(params);
  if (!filters) return undefined;
  const search = new URLSearchParams(filters);
  search.set(SearchFilters.BUSINESS_TYPE, SearchTypes.RENT_ROOM);
  return search.toString();
}
